import { DateTime } from "luxon";
export var addYears = function (date, years) {
    if (!date)
        return new Date();
    return DateTime.fromJSDate(date).plus({ years: years }).toJSDate();
};
export var addMonths = function (date, months) {
    if (!date)
        return new Date();
    return DateTime.fromJSDate(date).plus({ months: months }).toJSDate();
};
export var addWeeks = function (date, weeks) {
    if (!date)
        return new Date();
    return DateTime.fromJSDate(date).plus({ week: weeks }).toJSDate();
};
export var addDays = function (date, days) {
    if (!date)
        return new Date();
    return DateTime.fromJSDate(date).plus({ days: days }).toJSDate();
};
export var addHours = function (date, hours) {
    if (!date)
        return new Date();
    return DateTime.fromJSDate(date).plus({ hours: hours }).toJSDate();
};
export var addMinutes = function (date, minutes) {
    if (!date)
        return new Date();
    return DateTime.fromJSDate(date).plus({ minutes: minutes }).toJSDate();
};
export var startOfMonth = function (date) {
    return DateTime.fromJSDate(date).startOf('month').toJSDate();
};
export var endOfMonth = function (date) {
    return DateTime.fromJSDate(date).endOf('month').toJSDate();
};
export var startOfWeek = function (date) {
    return DateTime.fromJSDate(date).startOf('week').toJSDate();
};
export var endOfWeek = function (date) {
    return DateTime.fromJSDate(date).endOf('week').toJSDate();
};
export var startOfDay = function (date) {
    return DateTime.fromJSDate(date).startOf('day').toJSDate();
};
export var endOfDay = function (date) {
    return DateTime.fromJSDate(date).endOf('day').toJSDate();
};
export var formatFullDateTime = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('dd.MM.yyyy HH:mm:ss');
};
export var formatFullDMY = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('dd.MM.yyyy');
};
export var formatDayMonth = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('dd.MM');
};
export var formatDateTime = function (format, date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat(format);
};
export var formatDateHM = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('HH:mm');
};
export var formatDateHMRange = function (start, end) {
    if (!start || !end)
        return '-';
    return "".concat(formatDateHM(start), " \u2013 ").concat(formatDateHM(end));
};
export var formatDateDMYHM = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('dd.MM.yyyy HH:mm');
};
export var formatDateRelative = function (date, locale) {
    var _a;
    if (locale === void 0) { locale = 'en'; }
    if (!date)
        return '';
    return (_a = DateTime.fromJSDate(date).toRelative({ locale: locale })) !== null && _a !== void 0 ? _a : '';
};
export var formatDateLocalISO = function (date) {
    if (!date)
        return undefined;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
};
export var formatDateMDHM = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('dd.MM HH:mm');
};
export var isSameDay = function (date1, date2) {
    if (!date1 || !date2)
        return false;
    return startOfDay(date1).getTime() == startOfDay(date2).getTime();
};
export var convertLocalDateToDate = function (date) {
    if (!date)
        return undefined;
    return startOfDay(new Date(date));
};
export var inLast5Minutes = function (date) {
    if (!date)
        return false;
    var now = DateTime.now();
    var dateTime = DateTime.fromJSDate(date);
    return dateTime >= now.minus({ minutes: 5 }) && dateTime <= now;
};
export var formatFullDate = function (date) {
    if (!date)
        return '';
    return DateTime.fromJSDate(date).toFormat('dd.MM.yyyy');
};
export var diffInMinutes = function (date1, date2) {
    if (!date1 || !date2)
        return 0;
    var dateTime1 = DateTime.fromJSDate(date1);
    var dateTime2 = DateTime.fromJSDate(date2);
    return dateTime1.diff(dateTime2, 'minutes').minutes;
};
export var diffInDays = function (date1, date2) {
    if (!date1 || !date2)
        return 0;
    var dateTime1 = DateTime.fromJSDate(date1);
    var dateTime2 = DateTime.fromJSDate(date2);
    return dateTime1.diff(dateTime2, 'days').minutes;
};
export var isAfter = function (date1, date2) {
    if (!date1 || !date2)
        return false;
    return DateTime.fromJSDate(date1).diff(DateTime.fromJSDate(date2)).milliseconds > 0;
};
export var isBefore = function (date1, date2) {
    if (!date1 || !date2)
        return false;
    return DateTime.fromJSDate(date1).diff(DateTime.fromJSDate(date2)).milliseconds < 0;
};
export var formatLocalISOTimeToHM = function (time) {
    if (!time)
        return '';
    return time.replace('-', ':');
};
export var formatLocalISODateToDMY = function (date) {
    if (!date)
        return '';
    return formatFullDMY(convertLocalDateToDate(date));
};
export var attachCurrentTimeToOtherDate = function (date) {
    var now = new Date();
    var beginningOfDay = startOfDay(now);
    var diff = diffInMinutes(now, beginningOfDay);
    return addMinutes(date, diff);
};
// Used for voice note
export var formatTime = function (s) {
    var mins = Math.floor(s / 60);
    var secs = s % 60;
    return "".concat(mins, ":").concat(secs.toString().padStart(2, '0'));
};
export var formatDateRangePretty = function (date1, date2, locale) {
    var start = DateTime.fromJSDate(date1).setLocale(locale);
    var end = DateTime.fromJSDate(date2).setLocale(locale);
    // Same month and year: e.g. "27–30 July 2025"
    if (start.hasSame(end, 'month') && start.hasSame(end, 'year')) {
        return "".concat(start.toFormat('d'), "\u2013").concat(end.toFormat('d'), " ").concat(end.toFormat('LLLL yyyy'));
    }
    // Same year, different months: e.g. "30 July – 2 August 2025"
    if (start.hasSame(end, 'year')) {
        return "".concat(start.toFormat('d LLLL'), " \u2013 ").concat(end.toFormat('d LLLL yyyy'));
    }
    // Different years: e.g. "30 Dec 2025 – 2 Jan 2026"
    return "".concat(start.toFormat('d LLL yyyy'), " \u2013 ").concat(end.toFormat('d LLL yyyy'));
};
export var formatDateRangeShortDayMonth = function (start, end, locale) {
    if (locale === void 0) { locale = 'en'; }
    if (!start || !end)
        return '—';
    var fmt = { day: 'numeric', month: 'short' };
    var sameMonth = start.getMonth() === end.getMonth();
    var sameYear = start.getFullYear() === end.getFullYear();
    if (sameMonth && sameYear) {
        return "".concat(start.getDate(), "\u2013").concat(end.toLocaleDateString(locale, fmt));
    }
    return "".concat(start.toLocaleDateString(locale, fmt), " \u2013 ").concat(end.toLocaleDateString(locale, fmt));
};
export var isToday = function (input) {
    if (!input)
        return false;
    var dt;
    if (typeof input === "string") {
        // ISO date/time, or time-only like "13:44:23" / "13:44"
        dt = DateTime.fromISO(input);
        if (!dt.isValid)
            dt = DateTime.fromFormat(input, "HH:mm:ss");
        if (!dt.isValid)
            dt = DateTime.fromFormat(input, "HH:mm");
        if (!dt.isValid)
            return false;
    }
    else {
        dt = DateTime.fromJSDate(input);
    }
    return dt.hasSame(DateTime.local(), "day");
};
export var createDateBasedOnHHMM = function (timeString, baseDate) {
    if (baseDate === void 0) { baseDate = new Date(); }
    var _a = timeString.split(':'), hour = _a[0], minute = _a[1];
    var date = new Date(baseDate);
    date.setHours(parseInt(hour), parseInt(minute), 0, 0);
    return date;
};
export var createReservationStartDateBasedOnPeriod = function (checkInDate, period) {
    if (period === 'blank') {
        var now = new Date();
        var result = new Date(checkInDate !== null && checkInDate !== void 0 ? checkInDate : now);
        result.setHours(now.getHours(), now.getMinutes(), 0, 0);
        return result;
    }
    var hours;
    switch (period) {
        case 'breakfast':
            hours = 7;
            break;
        case 'lunch':
            hours = 12;
            break;
        case 'dinner':
            hours = 18;
            break;
        default:
            hours = 7;
    }
    // Otherwise we need to set the reservation to the next day at the appropriate time
    var newDate = new Date(checkInDate !== null && checkInDate !== void 0 ? checkInDate : new Date());
    newDate.setHours(hours, 0, 0, 0);
    // If the period is breakfast -> always set to the next day
    if (period === 'breakfast') {
        newDate.setDate(newDate.getDate() + 1);
    }
    return newDate;
};
export var serializeStoredDate = function (date, mode) {
    if (mode === void 0) { mode = 'fixed'; }
    return (JSON.stringify(mode === 'today'
        ? { mode: 'today' }
        : { mode: 'fixed', date: formatFullDMY(date) }));
};
export var parseStoredDate = function (storedValue) {
    if (!storedValue)
        return undefined;
    var dateValue = storedValue;
    if (storedValue.trimStart().startsWith('{')) {
        try {
            var storedDate = JSON.parse(storedValue);
            if (storedDate.mode === 'today')
                return startOfDay(new Date());
            if (storedDate.mode !== 'fixed' || typeof storedDate.date !== 'string')
                return undefined;
            dateValue = storedDate.date;
        }
        catch (_a) {
            return undefined;
        }
    }
    var _b = dateValue.split('.').map(Number), day = _b[0], month = _b[1], year = _b[2];
    if (!day || !month || !year)
        return undefined;
    var date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year
        || date.getMonth() !== month - 1
        || date.getDate() !== day)
        return undefined;
    return startOfDay(date);
};
